"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMark = void 0;
const react_1 = __importDefault(require("react"));
exports.CheckMark = (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#33CA7F" }),
    react_1.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.39209 11.8649L14.7132 5.53223L16.0206 6.84627L8.39209 14.4888L4 10.0886L5.30742 8.77461L8.39209 11.8649Z", fill: "white" })));
